import { createFileRoute, redirect } from '@tanstack/react-router';

import { Landing } from '#features/landing/components/Landing';
import { landingRouteHead, landingRouteLoader } from '#features/landing/utils/landingRoute';
import { homeRoute } from '#features/layout/utils/homeRoute';
import { envConfig } from '#constants/envConfig';

export const Route = createFileRoute('/{-$locale}/_layout/_landing/')({
  // The app opens at "/" (the static SPA shell), which on the web is the marketing
  // landing — wrong place to land inside an installed app, and the page carries the
  // Google Play block that store reviews object to. Send people to the product instead.
  // Folds away on the web: IS_NATIVE is a build-time constant.
  beforeLoad: ({ context }) => {
    if (envConfig.IS_NATIVE) {
      throw redirect({ to: homeRoute(context.isAuth), replace: true });
    }
  },
  component: () => <Landing gameSlug="index" />,
  loader: ({ context }) => landingRouteLoader(context.queryClient, 'index'),
  head: ({ loaderData, params }) => landingRouteHead('index', loaderData, params.locale),
});
